// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._7WpUEQyb3B3ClS6smQ1AcQ\\=\\={background:#e6f4f1}", "",{"version":3,"sources":["webpack://./resources/js/components/PostCard/styles.module.scss"],"names":[],"mappings":"AAAA,6BACI,kBACJ","sourcesContent":[".is_paid {\n    background: #e6f4f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"is_paid": "_7WpUEQyb3B3ClS6smQ1AcQ=="
};
export default ___CSS_LOADER_EXPORT___;
